import { ShaderInputs } from "./ShaderInputs";
import { ColorShader } from "./ColorShader";
import { FOG_CHUNK_FS, FOG_CHUNK_VS, FOG_UNIFORMS_FS, FOG_UNIFORMS_VS } from "./FogChunks";

export class ColorFogShader extends ColorShader implements ShaderInputs {
    // Uniforms are of type `WebGLUniformLocation`
    fogStartDistance: WebGLUniformLocation | undefined;
    fogDistance: WebGLUniformLocation | undefined;
    fogColor: WebGLUniformLocation | undefined;

    fillCode() {
        this.vertexShaderCode = `#version 300 es
        precision highp float;

        uniform mat4 view_proj_matrix;
        in vec4 rm_Vertex;

        ${FOG_UNIFORMS_VS}

        void main() {
            gl_Position = view_proj_matrix * rm_Vertex;
            ${FOG_CHUNK_VS}
        }`;

        this.fragmentShaderCode = `#version 300 es
        precision mediump float;

        uniform vec4 color;
        out vec4 fragColor;

        ${FOG_UNIFORMS_FS}

        void main() {
            fragColor = color;
            ${FOG_CHUNK_FS}
        }`;
    }

    fillUniformsAttributes() {
        super.fillUniformsAttributes();

        this.fogColor = this.getUniform("fogColor");
        this.fogStartDistance = this.getUniform("fogStartDistance");
        this.fogDistance = this.getUniform("fogDistance");

        this.attributes = [this.rm_Vertex!];
        this.uniforms = [
            this.view_proj_matrix!,
            this.color!,
            this.fogColor, // FS
            this.fogStartDistance, // VS
            this.fogDistance // VS
        ];
    }
}
